import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'utcToLocal',
  standalone: false
})
export class UtcToLocalPipe implements PipeTransform {
  transform(value: string | Date, format: string = 'dd/MM/yyyy HH:mm'): string {
    if (!value) {return '';}

    // Se è già un Date, lo uso direttamente
    let date: Date;
    if (value instanceof Date) {
      date = value;
    } else {
      // Se è una stringa, aggiungo 'Z' solo se non c'è già un timezone
      const hasTimezone = /[zZ]|[+-]\d{2}:\d{2}$/.test(value);
      date = new Date(hasTimezone ? value : value + 'Z');
    }

    // Controllo validità data
    if (isNaN(date.getTime())) {
      console.warn('utcToLocalPipe: valore non è una data valida:', value);
      return '';
    }

    // L'orario si include solo se il format richiesto contiene token di tempo (H/h/m/s).
    // Default 'dd/MM/yyyy HH:mm' → data+ora (comportamento storico invariato);
    // 'dd/MM/yyyy' → solo data (usato per campi date-only come Data prevista pianifica).
    const includeTime = /[Hhms]/.test(format);

    return new Intl.DateTimeFormat('it-IT', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      ...(includeTime ? { hour: '2-digit', minute: '2-digit' } : {})
    }).format(date);
  }
}
